import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeaderGuest, getActivationAttemptDataYourSim } from '../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import ActivationHead from './ActivationHead';


const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const isValidNo = /^[0-9]*$/;

const Summary = ({ handleDataStepOne,activationSuccessMsg, activationSuccessData, selectedPlanData, userAccountData , planDetails, clearDvsEntry }) => {
    console.log(activationSuccessData);
    console.log(activationSuccessMsg);
     
    console.log("selectedPlanData?.data?.payment_status ==>",selectedPlanData?.data?.payment_status )
    console.log("userAccountData.show_full_amount_only in summary",userAccountData.show_full_amount_only)
     console.log("selectedPlanData?.data?.payment_status in summary",selectedPlanData?.data?.payment_status)
    //const [payment_status, setPayment_status] = useState(selectedPlanData?.data?.payment_status);
    const [payment_status, setPayment_status] = useState(userAccountData?.portin_discount_applicable == 0 ? 1 : selectedPlanData?.data?.payment_status);




    useEffect(() => {

        // if(userAccountData.payment_status == false){
        //     setPayment_status(0);
        // }
        if(userAccountData?.payment_status == false){
            setPayment_status(0);
        }else{
            setPayment_status(1);

        }


    }, []);






       

     useEffect(() => {

        clearDvsEntry();
        const timer = setTimeout(() => {
          
          window.location.reload();
            

        }, 15000);
        
        
        // 10000 ms = 10 seconds
        return () => clearTimeout(timer);



    }, []);

    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">
                        <h6>Summary</h6>
                        <hr />
                        <br />

                        <div className="ad-mb-result add-mb-payment add-mb-summary">

                            <div className="col-lg-4">

                                <div className="details-block cd-block">
                                    <label className="formbold-form-label formbold-form-label-2">Customer Details</label>

                                    <table className="text-left">
                                        <tr>
                                            <td >{userAccountData.customer_name}</td>
                                        </tr>
                                        <tr>
                                            <td >{userAccountData.email}</td>
                                        </tr>
                                        <tr>
                                            <td >DOB: {userAccountData.user_dob}</td>
                                        </tr>

                                        <tr>
                                            <td >Address: {userAccountData.address}</td>
                                        </tr>

                                        <tr>
                                            <td>SIM : {planDetails.sim_type === 'eSIM' ? planDetails.sim_type : activationSuccessData.sim_number} </td>
                                        </tr>

                                        <tr>
                                            <td>Mobile Number: {activationSuccessData.mobile_number} </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {userAccountData.port_in_authority_date ? (
                                                    `PortIn Authority Date : ${userAccountData.port_in_authority_date}`
                                                ) : (
                                                    ''
                                                )}
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                                <div className="details-block cd-block">

                                    <label className="formbold-form-label formbold-form-label-2">Plan Details</label>

                                    <table className="text-left">
                                        <tr>
                                            <td >{userAccountData.offerName}</td>
                                        </tr>

                                        <tr>
                                            <td >Monthly</td>
                                        </tr>
                                        <tr>

                                        {/* <td>Total Amount Paid: <span className="add-mb-tt-pay">${userAccountData?.payment_amount?userAccountData?.payment_amount:0.00 }</span></td> */}
                                       
                                            {/* <td>
                                                Total Amount Paid: <span className="add-mb-tt-pay">${selectedPlanData?.data?.payment_status === 1 ? (
                                                    <>
                                                        {userAccountData.payment_amount}
                                                    </>
                                                ) : 0.00}

                                                </span>
                                            </td> */}

                                         
                                            {userAccountData.show_full_amount_only === true ? 
                                                <>

                                                    <tr>   
                                                        <td>
                                                            Payable Amount: <span className="add-mb-tt-pay">${userAccountData.plan_amount}</span>
                                                        </td>

                                                    </tr>

                                                </>
                                                :
                                                <>
                                                    {userAccountData?.premium_number_amount > 0 ? (

                                                        <tr>
                                                            <td>

                                                                Premium Number Amount <span style={{ color: '#d6006d' }}>({userAccountData.premium_category_name})</span>: <span className="add-mb-tt-pay">${userAccountData.premium_number_amount}</span>
                                                                <div style={{ fontStyle: 'italic', color: '#6c6c6c', fontSize: '13px', marginBottom: '5px' }}>
                                                                    {userAccountData.premium_number_amount_text}
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    ) : ''}
                                                    {userAccountData?.premium_amount_with_gst > 0 ? (

                                                        <tr>
                                                            <td>

                                                                Premium Number Offer Amount <span style={{ color: '#d6006d' }}>({userAccountData.premium_category_name})</span>: <span className="add-mb-tt-pay">${userAccountData.premium_amount_with_gst}</span>
                                                                <div style={{ fontStyle: 'italic', color: '#6c6c6c', fontSize: '13px', marginBottom: '5px' }}>
                                                                    {userAccountData.premium_number_amount_text}
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    ) : ''}

                                                    <tr> 
                                                        <td >
                                                            Retailer Price: <span className="add-mb-tt-pay">${userAccountData.retailer_price}</span>
                                                        </td>
                                                    </tr> 



                                                    <tr> 
                                                        <td >
                                                            Wallet Credit Used: <span className="add-mb-tt-pay"> ${Number(userAccountData.wallet_credit_used).toFixed(2)}</span>
                                                        </td>
                                                    </tr>  
                                                    

                                                    <tr>   
                                                        <td>
                                                            Payable Amount: <span className="add-mb-tt-pay">${payment_status === 1 ? (
                                                                <>
                                                                {Number(userAccountData.payment_amount).toFixed(2)} 
                                                                </>
                                                                ): Number(0).toFixed(2) }
                                                              
                                                                </span>
                                                        </td>

                                                    </tr>
                                                    
                                                </>
                                                }



                                        </tr>
                                        {activationSuccessData?.invoice_no && (
                                            <tr>
                                                <td>Invoice Number: {activationSuccessData.invoice_no}</td>
                                            </tr>
                                        )
                                        }
                                        
                                    </table>
                                </div>
                            </div>
                            <div className="col-lg-1 payment-secion">
                            </div>
                            <div className="col-lg-7 summaryBox">
                                <br />
                                <div className="suc-icon">
                                    <div className="circle">
                                        <i className="fa fa-check"></i>
                                    </div>
                                </div>
                                <p className="summ-msg">{activationSuccessData.success_message}</p>
                                <p className="summ-note">
                                    <span>{activationSuccessMsg.activation_message}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
};

export default Summary;
